import StoreContext from "contexts/StoreContext";
import React, { useContext, useEffect, useState } from "react";
import { Card, Row, Col } from "react-bootstrap";
import { apiService } from "service/ApiService";
import CountUp from "react-countup";
import { useTranslation } from "react-i18next";

function PeopleCard() {
  const { t } = useTranslation();
  const [value, setValue] = useState(0);
  const { storeId, setStoreId } = useContext(StoreContext);

  const getStoreValue = () => {
    if (!storeId) return;
    apiService
      .get(`api/v1/stores/${storeId}/people`)
      .then((resp) => setValue(resp.total ? resp.total : 0))
      .catch((error) => {
        console.error(error);
        setValue(0);
      });
  };

  useEffect(() => {
    getStoreValue();
  }, [storeId]);

  return (
    <Card className="card-stats">
      <Card.Body>
        <Row>
          <Col xs="2">
            <div className="icon-big text-center">
              <i className="nc-icon nc-single-02 text-primary"></i>
            </div>
          </Col>
          <Col xs="10">
            <div className="numbers">
              <p className="card-category">{t("dashboard.cards.people")}</p>
              <Card.Title as="h4">
                <CountUp start={0} end={value} duration={2} />
              </Card.Title>
            </div>
          </Col>
        </Row>
      </Card.Body>
    </Card>
  );
}

export default PeopleCard;
